export default __webpack_public_path__ + "./images/cn.6336817e.png";